import { render, staticRenderFns } from "./sensibilityText.vue?vue&type=template&id=4824e40c&scoped=true&"
import script from "./sensibilityText.vue?vue&type=script&lang=js&"
export * from "./sensibilityText.vue?vue&type=script&lang=js&"
import style0 from "./sensibilityText.vue?vue&type=style&index=0&id=4824e40c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4824e40c",
  null
  
)

export default component.exports